import React, { Component } from 'react';
import styled from 'styled-components';
import Textarea from 'react-textarea-autosize';
import { media } from 'lib/style-utils';
import axios from 'axios';
import { validate } from 'email-validator';
import { mailServerUri } from 'lib/serverInfo';

const Wrapper = styled.div`
  margin: 60px auto 0;
  width: 100%;
  height: 100vh;
  background-image: url('/images/contact/form-bg.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;

  ${media.w1200`
    height: 960px;
  `}
  ${media.mobile`
    background-image: none;
  `}
`;

const WhiteBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 500px;
  width: 100%;
  padding: 78px;
  height: 870px;
  border-radius: 10px;
	background-color: #ffffff;
  border: solid 1px #edecea;

  ${media.mobile `
    width: 90%;
    padding: 35px 20px;
    height: 699px;
  `}
`;

const Title = styled.div`
  font-size: 17px;
  text-align: left;
  color: #343434;

  ${media.mobile `
    font-size: 13px;
  `}
`;

const Input = styled.input`
  margin: 10px auto 30px;
  padding: 0 15px;
  width: 90%;
  height: 50px;
  background-color: #ffffff;
  border: solid 1px #eeeeee;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.8;
  color: #444444;

  ${media.mobile`
    height: 32px;
  `}
`;

const Select = styled.select`
  position: relative;
  margin: 10px auto 30px;
  padding: 0 0 0 15px;
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  border: solid 1px #eeeeee;
  border-radius: 0%;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.8;
  color: #777777;
  -webkit-appearance: none;
  -moz-appearance: none;

  ${media.mobile`
    height: 35px;
  `}
`;

const StyledTextArea = styled(Textarea)`
  margin: 10px auto 0;
  padding: 0 15px;
  width: 90%;
  border: none;
  outline: none;
  background-color: #ffffff;
  border: solid 1px #eeeeee;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.8;
  color: #444444;
  resize: none;
  border-radius: 0;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
`;

const Send = styled.button`
  display: block;
  width: 154px;
  height: 45px;
  margin: 20px auto 0;
  border-radius: 23px;
  background-color: #ffffff;
  border: solid 1px #eeeeee;
  font-family: Lato;
  font-size: 14px;
  letter-spacing: 0.7px;
  color: #aaaaaa;
  text-align: center;
  cursor: pointer;

  &:hover {
    background: #f9f9f9;
  }

  &:active {
    background: #f2f2f2;
    transform: translateY(1px);
  }
`;

class Form extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps;
  }

  handleChange = (e) => {
    const { FormActions } = this.props;
    const { changeName, changeTel, changeEmail, changeAbout, changeMessage } = FormActions;
    const { name, value } = e.target;

    if (name === 'name') {
      changeName(value);
    } else if (name === 'tel') {
      changeTel(value);
    } else if (name === 'email') {
      changeEmail(value);
    } else if (name === 'about') {
      changeAbout(value);
    } else if (name === 'message') {
      changeMessage(value);
    }
  }

  handleSendMail = () => {
    const { name, tel, email, about, message, brand, FormActions } = this.props;
    const { showNotice, setMessage, resetForm } = FormActions;
    const validateMail = validate(email);
    const mailServer = process.env.NODE_ENV === 'production' ? mailServerUri.production : mailServerUri.dev;

    if (message.indexOf('<script') > -1) {
      setMessage('악의적인 script는 제외 바랍니다.');
      showNotice();
    } else if (!name || !tel || !email || !about) {
      setMessage('모두 정확히 입력해주세요.');
      showNotice();
    } else if (!validateMail) {
      setMessage('옳바르지 않은 이메일 주소입니다.');
      showNotice();
    } else if (message.trim().length <= 1) {
      setMessage('문의 내용을 작성해주세요.');
      showNotice();
    } else {
      axios.post(mailServer + '/send', { name, tel, email, about, message, brand })
      .then(data => {
        if (data.status === 200) {
          setMessage(`${name}님의 문의내용이 성공적으로 발송되었습니다.`);
          showNotice();
          resetForm();
        } else {
          setMessage('죄송합니다. 이메일 전송에 실패하였습니다.');
          showNotice();
        }
      })
      .catch(err => {
        console.log(err);
      })
    }
  }

  render() {
    const { name, tel, email, about, message } = this.props;
    const { handleChange, handleSendMail } = this;

    return (
      <Wrapper>
        <WhiteBox>
          <form>
            <label>
              <Title>Name / Name of company</Title>
              <Input
                name="name"
                type="text"
                onChange={handleChange}
                placeholder=""
                value={name}
              />
            </label>

            <label>
              <Title>Phone Number</Title>
              <Input
                name="tel"
                type="tel"
                onChange={handleChange}
                placeholder=""
                value={tel}
              />
            </label>

            <label>
              <Title>E-mail</Title>
              <Input
                name="email"
                type="email"
                onChange={handleChange}
                placeholder=""
                value={email}
              />
            </label>

            <label className="select">
              <Title>Subject</Title>
              <Select
                name="about"
                onChange={handleChange}
                placeholder=""
                value={about}
              >
                <option value="" disabled defaultValue>Choose</option>
                <option value="Wholesale 문의">Wholesale</option>
                <option value="협업 문의">Collaboration</option>
                <option value="협찬 문의">Sponsor</option>
              </Select>
            </label>

            <label>
              <Title>Message</Title>
              <StyledTextArea
                name="message"
                type="text"
                minRows={7}
                maxRows={20}
                placeholder=""
                value={message}
                onChange={handleChange}
              />
            </label>
          </form>

            <Send
              onClick={handleSendMail}
            >SEND</Send>
        </WhiteBox>
      </Wrapper>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/Contact/Form.js